/* eslint-disable import/no-duplicates */

const LandingPageData = { 
  copyRight: 'Copyright © 2025 All rights reserved',
};

export default LandingPageData;
